const getFormatPhone = (phone: string) => {
  const digitPhone = ['02', '03', '04', '05', '07']; // สำหรับ 9 หลัก
  const subNumber = phone.substring(0, 2);
  const index = digitPhone.findIndex((digit) => digit === subNumber);
  const format = index === -1 ? '(###) ### ####' : '(##) ### ####';
  return format;
};

const displayFormatIdentity = (value: string): string => {
  const cleanValue = `${value}`.replace(/\D/g, '');

  // Format the cleaned value as #-####-#####-##-#

  return `${cleanValue}`.replace(/(\d{1})(\d{4})(\d{5})(\d{2})(\d{1})/, '$1-$2-$3-$4-$5');
};

const displayFormatBankNumber = (value: string): string => {
  const cleanValue = `${value}`.replace(/\D/g, '');

  // Format the cleaned value as ###-#-#####-#
  return `${cleanValue}`.replace(/(\d{3})(\d{1})(\d{5})(\d{1})/, '$1-$2-$3-$4');
};

const displayFormatPhone = (value: string): string => {
  const digitPhone = ['02', '03', '04', '05', '07'];
  const cleanValue = `${value}`.replace(/\D/g, '');

  const startsWithDigitPhone = digitPhone.some((prefix) => cleanValue.startsWith(prefix));

  // Format the phone number based on the first digits
  if (startsWithDigitPhone && cleanValue.length === 9) {
    // Format as ##-###-####
    return `${cleanValue}`.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
  } else if (cleanValue.length === 10) {
    // Format as ###-###-####
    return `${cleanValue}`.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  } else {
    // If the number doesn't match the expected length, return the original value
    return value;
  }
};

export { getFormatPhone, displayFormatIdentity, displayFormatPhone, displayFormatBankNumber };
